import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ResourceData } from '@app/shared/abstract/resource.data';
import { EventModel } from './event.model';

@Injectable({
  providedIn: 'root',
})
export class EventRulesConductService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  submit(eventId: number | string, acknowledgements: boolean[]): Observable<ResourceData<EventModel> & { message: string }> {
    return this.http.post<ResourceData<EventModel> & { message: string }>(
      `${this.apiUrl}/api/events/${eventId}/rules-conduct/submit`,
      { acknowledgements },
    );
  }

  reset(eventId: number | string): Observable<ResourceData<EventModel> & { message: string }> {
    return this.http.post<ResourceData<EventModel> & { message: string }>(
      `${this.apiUrl}/api/events/${eventId}/rules-conduct/reset`,
      {},
    );
  }
}
